<a routerLink="/mentions-legales">Mentions légales</a>
<a routerLink="/contact-us">Nous contacter</a>
<a>Version : {{appVersion}}</a>